import React from 'react';
import { defineMessages } from 'react-intl';

import { noop } from 'ui-components/default-props/noop';

import { CarrierPickupModalV2 } from '.';

// NOTE: 2:30 PM - 5:00 PM relative to warehouse timezone as per requirements
const fixedPickupWindowStartTime = '14:30:00';
const fixedPickupWindowEndTime = '17:00:00';
// Note: This cutt off is also relative to the shipFrom location's time zone
const sixPmCutOff = '18:00:00';
const minimumDaysInAdvance = 1;

const messages = defineMessages({
  flatFeeMessage: {
    id: 'IT4Flo',
    description: 'Flat fee pricing message',
    // TODO: USD for now since amazon is only US
    defaultMessage: 'Pickup is a flat $9.05 fee no matter how many items you hand off.',
  },
  submissionDeadlineMessage: {
    id: 'qKV5Rx',
    description: 'Submission deadline warning message',
    defaultMessage: 'Pickups for the next day must be submitted before 6 PM.',
  },
});

export const AmazonPickup = ({ onClose = noop, onCreated = noop, sellerLabelProviderId = '' }) => {
  return (
    <CarrierPickupModalV2
      bodyNoteMessageDescriptor={messages.flatFeeMessage}
      fixedWarehouseTimeEnd={fixedPickupWindowEndTime}
      fixedWarehouseTimeStart={fixedPickupWindowStartTime}
      footerNoteMessageDescriptor={messages.submissionDeadlineMessage}
      hasFixedTimeWindow
      maxCutOffSchedulingHourRelative={sixPmCutOff}
      minimumDaysInAdvance={minimumDaysInAdvance}
      onClose={onClose}
      onCreated={onCreated}
      sellerLabelProviderId={sellerLabelProviderId}
      shouldDisableSundayPickups
    />
  );
};
